import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ProductosData.css'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewProduct from '../NewProduct/NewProduct';
import moneda from '../../moneda';
import { Link as Anchor } from "react-router-dom";
import imageIcon from '../../../images/imageIcon.png';
import { fetchUsuario, getUsuario } from '../../user';
import ImageConverter from '../ImageConverter/ImageConverter';
export default function ProductosData() {
    const [productos, setProductos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [producto, setProducto] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroCategoria2, setFiltroCategoria2] = useState('');
    const [filtroMasVendido, setFiltroMasVendido] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [imagenPreview, setImagenPreview]   = useState([null, null, null, null]);
    const [webpFiles, setWebpFiles]           = useState([null, null, null, null]);
    const [selectedSection, setSelectedSection] = useState('texto');
    const [nuevoMasVendido, setNuevoMasVendido] = useState('');
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [nuevoStock, setNuevoStock] = useState('');
    const [subcategorias, setSubCategorias] = useState([]);
    const [visibleCount, setVisibleCount] = useState(20);
    const [categoriasConSubcategorias, setCategoriasConSubcategorias] = useState([]);
    const [idCategoria, setIdCategoria] = useState('');
    const [idSubCategoria, setIdSubCategoria] = useState('');
    const [mostrarItems, setMostrarItems] = useState(false);
    const [cantidadStock, setCantidadStock] = useState('');
    const [verItems, setVerItems] = useState('No');
    const handleShowMore = () => {
        setVisibleCount(prevCount => prevCount + 20);
    };

    useEffect(() => {
        cargarCategoriasYSubcategorias();
    }, []);
    const cargarCategoriasYSubcategorias = async () => {
        try {
            const [categoriasRes, subcategoriasRes] = await Promise.all([
                fetch(`${baseURL}/categoriasGet.php`).then(res => res.json()),
                fetch(`${baseURL}/subCategoriaGet.php`).then(res => res.json()),
            ]);

            const categorias = categoriasRes.categorias || [];
            const subcategorias = subcategoriasRes.subcategorias || [];

            const categoriasConSub = categorias.map(categoria => {
                return {
                    ...categoria,
                    subcategorias: subcategorias.filter(sub => sub.idCategoria === categoria.idCategoria),
                };
            });

            setCategoriasConSubcategorias(categoriasConSub);
        } catch (error) {
            console.error('Error al cargar categorías y subcategorías:', error);
        }
    };

    const handleCategoriaSeleccion = (e) => {
        const selectedValue = e.target.value;

        // Separar idCategoria de idSubCategoria si está presente
        const [categoriaId, subCategoriaId] = selectedValue.split('-');

        setIdCategoria(categoriaId);

        if (subCategoriaId) {
            setIdSubCategoria(subCategoriaId);
        } else {
            setIdSubCategoria(''); // No subcategoría seleccionada
        }
    };
    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };
    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };


    useEffect(() => {
        cargarProductos();

    }, []);

    useEffect(() => {
        if (!producto?.idProducto) return; // evita ejecutarse con objeto vacío al montar
        setNuevoTitulo(producto.titulo ?? '');
        setNuevaDescripcion(producto.descripcion ?? '');
        setNuevoPrecio(producto.precio ?? '');
        setNuevoMasVendido(producto.masVendido ?? '');
        setIdCategoria(producto.idCategoria ?? '');
        setIdSubCategoria(producto.idSubCategoria ?? '');
        setItem1(producto.item1 ?? '');
        setItem2(producto.item2 ?? '');
        setItem3(producto.item3 ?? '');
        setItem4(producto.item4 ?? '');
        setItem5(producto.item5 ?? '');
        setItem6(producto.item6 ?? '');
        setItem7(producto.item7 ?? '');
        setItem8(producto.item8 ?? '');
        setItem9(producto.item9 ?? '');
        setItem10(producto.item10 ?? '');
        setNuevoPrecioAnterior(producto.precioAnterior ?? 0);
        setNuevoStock(producto.stock ?? '');
        setVerItems(producto.verItems ?? 'No');
    }, [producto]);

    const cargarProductos = (nocache = false) => {
        const _url = nocache
            ? `${baseURL}/productosGet.php?nocache=${Date.now()}`
            : `${baseURL}/productosGet.php`;
        fetch(_url, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                console.log(data.productos)
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const eliminarProducto = (idProducto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/productDelete.php?idProducto=${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        window.location.reload();
                        cargarProductos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setNuevoTitulo(item.titulo);
        setNuevaDescripcion(item.descripcion);
        setNuevoPrecio(item.precio);
        setImagenPreview([null, null, null, null]);
        setWebpFiles([null, null, null, null]);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setMostrarItems(false)
    };

    const productosFiltrados = productos.filter(item => {
        const idMatch = item.idProducto.toString().includes(filtroId);
        const tituloMatch = !filtroTitulo || item.titulo.toLowerCase().includes(filtroTitulo.toLowerCase());
        const categoriaMatch = !filtroCategoria || item.idCategoria.toString() === filtroCategoria;
        const masVendidoMatch = !filtroMasVendido || item.masVendido.includes(filtroMasVendido);
        const categoriasMatch = !filtroCategoria2 || item.categoria.includes(filtroCategoria2);
        return idMatch && tituloMatch && categoriaMatch && masVendidoMatch && categoriasMatch;
    });

    const descargarExcel = () => {
        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Titulo: item.titulo,
            Descripcion: item.descripcion,
            Precio: item.precio,
            Fecha: item.createdAt,
            MasVendido: item.masVendido,
            Imagen1: item.imagen1,
            Imagen2: item.imagen2,
            Imagen3: item.imagen3,
            Imagen4: item.imagen4,

        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'productos.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Productos', 10, 10);

        const columns = [
            { title: 'IdProducto', dataKey: 'idProducto' },
            { title: 'Titulo', dataKey: 'titulo' },
            { title: 'Descripcion', dataKey: 'descripcion' },
            { title: 'Precio', dataKey: 'precio' },
            { title: 'MasVendido', dataKey: 'masVendido' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Titulo: item.titulo,
            Descripcion: item.descripcion,
            Precio: item.precio,
            MasVendido: item.masVendido,
            Fecha: item.createdAt,

        }));

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('productos.pdf');
    };

    const recargarProductos = () => {
        cargarProductos();
    };
    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };


    const handleUpdateText = async (idProducto) => {
        const payload = {
            nuevoTitulo:       nuevoTitulo?.trim()      ?? '',
            nuevaDescripcion:  nuevaDescripcion?.trim() ?? '',
            nuevoPrecio:       nuevoPrecio               ?? 0,
            nuevaCategoria:    idCategoria               ?? '',
            nuevaSubCategoria: idSubCategoria            || '0',
            masVendido:        nuevoMasVendido           ?? 'no',
            item1:  item1  ?? '',
            item2:  item2  ?? '',
            item3:  item3  ?? '',
            item4:  item4  ?? '',
            item5:  item5  ?? '',
            item6:  item6  ?? '',
            item7:  item7  ?? '',
            item8:  item8  ?? '',
            item9:  item9  ?? '',
            item10: item10 ?? '',
            precioAnterior: nuevoPrecioAnterior ?? 0,
            stock: nuevoStock === 'elegir' ? cantidadStock : (nuevoStock ?? 0),
            verItems: verItems ?? 'No',
        };

        fetch(`${baseURL}/productoTextPut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {

                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {

                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarProductos(true);
                    cerrarModal()
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    // ── Handlers para ImageConverter ──────────────────────────
    const handleImagenConverted = (index, webpFile, previewUrl) => {
        setWebpFiles(prev => { const n = [...prev]; n[index] = webpFile; return n; });
        setImagenPreview(prev => { const n = [...prev]; n[index] = previewUrl; return n; });
    };

    const handleImagenRemove = (index) => {
        setWebpFiles(prev => { const n = [...prev]; n[index] = null; return n; });
        setImagenPreview(prev => { const n = [...prev]; n[index] = null; return n; });
    };
    const handleEditarImagenBanner = async (idProducto) => {
        const formData = new FormData();
        formData.append('idProducto', idProducto);
        formData.append('updateAction', 'update');

        webpFiles.forEach((file, index) => {
            if (file) formData.append(`imagen${index + 1}`, file, file.name);
        });
        fetch(`${baseURL}/productoImagePut.php`, {
            method: 'POST',  // Cambiado a POST
            body: formData
        })
            .then(response => {
                // Manejar el caso cuando la respuesta no es un JSON válido o está vacía
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');

                }

                return response.json();
            })
            .then(data => {
                if (data.error) {

                    toast.error(data.error);
                    console.log(formData)
                } else {

                    toast.success(data.mensaje);
                    window.location.reload();
                }
            })
            .catch(error => {
                console.log(error)
                toast.error(error.message);
                console.log(formData)
                console.log(idProducto)
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    useEffect(() => {
        cargarCategoria();
        cargarSubCategoria();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarSubCategoria = () => {
        fetch(`${baseURL}/subCategoriaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSubCategorias(data.subcategorias || []);
                console.log(data.subcategorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setVerItems(isChecked ? 'Si' : 'No');
        setMostrarItems(isChecked);
    };
    async function guardarCambios(idProducto) {
        await handleUpdateText(idProducto);
        if (webpFiles.some(f => f !== null)) {
            await handleEditarImagenBanner(idProducto);
        }
    }
    //Trae usuario logueado-----------------------------
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);
    const usuarioLegued = getUsuario();
    const alertPermiso = () => {
        Swal.fire(
            '¡Error!',
            '¡No tienes permisos!',
            'error'
        );
    }
    return (
        <div>

            <ToastContainer />
            <div className='deFlexContent'>

                <div className='deFlex2'>
                    <NewProduct />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <button  >{String(productosFiltrados?.length)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")} / {String(productos?.length)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")} </button>
                    </div>
                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Producto' />
                    </div>

                    <div className='inputsColumn'>
                        <input type="text" value={filtroTitulo} onChange={(e) => setFiltroTitulo(e.target.value)} placeholder='Titulo' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
                            <option value="">Categorias</option>
                            {
                                categorias.map(item => (
                                    <option value={item?.idCategoria}>{item?.categoria}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroMasVendido} onChange={(e) => setFiltroMasVendido(e.target.value)}>
                            <option value="">Más vendidos</option>
                            <option value="si">Si</option>
                            <option value="no">No</option>

                        </select>
                    </div>

                    <button className='reload' onClick={recargarProductos}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>


            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">


                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>

                        <img src={imagenSeleccionada} alt="Imagen Seleccionada" />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset id='titulo'>
                                    <legend>Titulo (*)</legend>
                                    <input
                                        type="text"
                                        value={nuevoTitulo}
                                        onChange={(e) => setNuevoTitulo(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Categoría (*)</legend>
                                    <select
                                        id="categoriaSeleccionada"
                                        name="categoriaSeleccionada"
                                        value={idSubCategoria ? `${idCategoria}-${idSubCategoria}` : `${idCategoria}`}
                                        onChange={handleCategoriaSeleccion}
                                        required
                                    >
                                        <option value="">Categoría / subcategoría</option>
                                        {categoriasConSubcategorias.map(categoria => (
                                            <optgroup key={categoria.idCategoria} label={categoria.categoria}>
                                                <option value={`${categoria.idCategoria}`}>{categoria.categoria}</option>
                                                {categoria.subcategorias.map(subcategoria => (
                                                    <option key={subcategoria.idSubCategoria} value={`${categoria.idCategoria}-${subcategoria.idSubCategoria}`}>
                                                        {categoria.categoria} {`>`} {subcategoria.subcategoria}
                                                    </option>
                                                ))}
                                            </optgroup>
                                        ))}
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Precio (*)</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecio}
                                        onChange={(e) => setNuevoPrecio(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio anterior </legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioAnterior}
                                        onChange={(e) => setNuevoPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Más vendido (*)</legend>
                                    <select
                                        value={nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido}
                                        onChange={(e) => setNuevoMasVendido(e.target.value)}
                                    >
                                        <option value="">-- Seleccionar --</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Stock (*)</legend>
                                    <select
                                        value={nuevoStock}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setNuevoStock(value);
                                            if (value === 'elegir') {
                                                setCantidadStock(producto.stock); // Asigna el stock actual al campo cantidadStock
                                            }
                                        }}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value={1}>Disponible</option>
                                        <option value={0}>Agotado</option>
                                        <option value="elegir">Ingrese cantidad</option>
                                    </select>
                                    {nuevoStock === 'elegir' && (
                                        <input
                                            type="number"
                                            min="0"
                                            placeholder="Ingrese cantidad"
                                            value={cantidadStock} // Muestra el valor inicial del stock o el nuevo valor ingresado
                                            onChange={(e) => setCantidadStock(e.target.value)}
                                            required
                                        />
                                    )}
                                </fieldset>

                                <fieldset>
                                    <legend>Descripcion </legend>
                                    <textarea
                                        type="text"
                                        value={nuevaDescripcion}
                                        onChange={(e) => setNuevaDescripcion(e.target.value)}
                                    />
                                </fieldset>
                                <div id='textLabel'>
                                    <label>Items (opcional)</label>
                                    <div id='flexLabel'>
                                        Dar a elegir a los clientes
                                        <input
                                            type="checkbox"
                                            value={verItems}
                                            checked={verItems === "Si"}
                                            onChange={handleCheckboxChange}
                                        />
                                    </div>
                                </div>


                                {verItems === 'Si' && (
                                    <div className='items'>
                                        <fieldset>
                                            <legend>Item1</legend>
                                            <input
                                                type="text"
                                                id="item1"
                                                name="item1"
                                                required
                                                value={item1}
                                                onChange={(e) => setItem1(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item2</legend>
                                            <input
                                                type="text"
                                                id="item2"
                                                name="item2"
                                                required
                                                value={item2}
                                                onChange={(e) => setItem2(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item3</legend>
                                            <input
                                                type="text"
                                                id="item3"
                                                name="item3"
                                                required
                                                value={item3}
                                                onChange={(e) => setItem3(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item4</legend>
                                            <input
                                                type="text"
                                                id="item4"
                                                name="item4"
                                                required
                                                value={item4}
                                                onChange={(e) => setItem4(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item5</legend>
                                            <input
                                                type="text"
                                                id="item5"
                                                name="item5"
                                                required
                                                value={item5}
                                                onChange={(e) => setItem5(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item6</legend>
                                            <input
                                                type="text"
                                                id="item6"
                                                name="item6"
                                                required
                                                value={item6}
                                                onChange={(e) => setItem6(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item7</legend>
                                            <input
                                                type="text"
                                                id="item7"
                                                name="item7"
                                                required
                                                value={item7}
                                                onChange={(e) => setItem7(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item8</legend>
                                            <input
                                                type="text"
                                                id="item8"
                                                name="item8"
                                                required
                                                value={item8}
                                                onChange={(e) => setItem8(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item9</legend>
                                            <input
                                                type="text"
                                                id="item9"
                                                name="item9"
                                                required
                                                value={item9}
                                                onChange={(e) => setItem9(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset>
                                            <legend>Item10</legend>
                                            <input
                                                type="text"
                                                id="item10"
                                                name="item10"
                                                required
                                                value={item10}
                                                onChange={(e) => setItem10(e.target.value)}
                                            />
                                        </fieldset>


                                    </div>
                                )}

                            </div>
                            <label id='textLabel'>Imagenes</label>
                            <div className='previevProduct'>
                                {[1, 2, 3, 4].map((n, i) => (
                                    imagenPreview[i] ? (
                                        <img key={i} src={imagenPreview[i]} alt={`Vista previa ${n}`} onClick={() => abrirModalImagenSeleccionada(imagenPreview[i])} />
                                    ) : producto[`imagen${n}`] ? (
                                        <img key={i} src={producto[`imagen${n}`]} alt={`imagen${n}`} onClick={() => abrirModalImagenSeleccionada(producto[`imagen${n}`])} />
                                    ) : (
                                        <span key={i} className='imgNone'>No hay imagen</span>
                                    )
                                ))}
                            </div>

                            <div className='image-container'>
                                {[...Array(4)].map((_, index) => (
                                    <ImageConverter
                                        key={index}
                                        index={index}
                                        preview={imagenPreview[index]}
                                        selected={webpFiles[index] !== null}
                                        imageIcon={imageIcon}
                                        onConverted={handleImagenConverted}
                                        onRemove={handleImagenRemove}
                                    />
                                ))}
                            </div>
                            <button className='btnPost' onClick={() => guardarCambios(producto.idProducto)} >Guardar </button>

                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagenes' ? 'flex' : 'none' }}>

                            <button className='btnPost' onClick={() => handleEditarImagenBanner(producto.idProducto)}>Guardar </button>

                        </div>



                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Imagen</th>
                            <th>Titulo</th>
                            <th>Precio</th>
                            <th>Categoria</th>
                            <th>Subcategoria</th>
                            <th>Stock</th>
                            <th>Más vendido</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productosFiltrados?.slice(0, visibleCount)?.map(item => (
                            <tr key={item.idProducto}>

                                <td>
                                    {item.imagen1 ? (
                                        <img src={item.imagen1} alt="imagen1" style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px" }} />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>{item.titulo}</td>

                                <td style={{
                                    color: '#008000',
                                }}>
                                    {moneda} {`${item?.precio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </td>

                                {categorias
                                    ?.filter(categoriaFiltrada => categoriaFiltrada.idCategoria === item.idCategoria)
                                    ?.map(categoriaFiltrada => (
                                        <td
                                            key={categoriaFiltrada.idCategoria}
                                            style={{ color: '#DAA520' }}
                                        >
                                            {categoriaFiltrada.categoria}
                                        </td>
                                    ))
                                }
                                <td>
                                    {item.idSubCategoria === 0
                                        ? 'sin seleccionar'
                                        :
                                        <>
                                            {subcategorias
                                                ?.filter(subcategoriaFiltrada => subcategoriaFiltrada.idSubCategoria === item.idSubCategoria)
                                                ?.map(subcategoriaFiltrada => (
                                                    <>
                                                        {subcategoriaFiltrada?.subcategoria}
                                                    </>
                                                ))
                                            }
                                        </>
                                    }
                                </td>


                                {item.stock === 1 ? (
                                    <td style={{ color: '#008000' }}>Disponible</td>
                                ) : item.stock <= 0 ? (
                                    <td style={{ color: 'red' }}>Agotado</td>
                                ) : (

                                    <td>{item.stock}</td>
                                )}
                                {item.masVendido === 'si' ? (
                                    <td style={{ color: '#008000' }}>Si</td>
                                ) : item.masVendido === 'no' ? (
                                    <td style={{ color: 'red' }}>No</td>
                                ) : (
                                    <td></td>
                                )}


                                <td>
                                    {loading ? (
                                        <></>
                                    ) : usuarioLegued?.idUsuario ? (
                                        <>
                                            {usuarioLegued?.rol === 'admin' ? (
                                                <>
                                                    <button className='eliminar' onClick={() => eliminarProducto(item.idProducto)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                    <button className='editar' onClick={() => abrirModal(item)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <Anchor className='editar' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </Anchor>
                                                </>
                                            ) : usuarioLegued?.rol === 'colaborador' ? (
                                                <>
                                                    <button className='eliminar' onClick={() => eliminarProducto(item.idProducto)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                    <button className='editar' onClick={() => abrirModal(item)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <Anchor className='editar' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </Anchor>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <button className='eliminar' onClick={() => eliminarProducto(item.idProducto)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                            <button className='editar' onClick={() => abrirModal(item)}>
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <Anchor className='editar' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                                <FontAwesomeIcon icon={faEye} />
                                            </Anchor>
                                        </>
                                    )}

                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
            {productosFiltrados?.length > visibleCount && (
                <button onClick={handleShowMore} id="show-more-btn">
                    Mostrar  más </button>
            )}
        </div>
    );
};
